import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["button", "pageType", "title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { TeaserBanner } from '@beef/smart-kit';
import { scrollToBlock } from '@fttb/common/utils';
import { sendAnalyticsOnHeadingBannerClick } from "../../analytics";
import { FttbBlocks } from "../../constants";
import { withAnalyticsOnBlockView } from "../../hoc/withAnalyticsOnView";
import { getHeadingBackgroundColor, getHeadingBannerButtonLink, getHeadingBannerButtonText, getHeadingBannerText, getHeadingTitle, getIsDivider, getTextColor, getTitleColor, getTitleImgUrl, getVariant } from "../../../store/blocks/heading/selectors";
import { getAnalyticEventType } from "../../../store/blocks/selectors";
var _HeadingBanner = function _HeadingBanner(_ref) {
  var button = _ref.button,
    pageType = _ref.pageType,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  var onClick = useCallback(function () {
    if (typeof window === 'undefined') return;
    if (window.location.hash === FttbBlocks.TARIFFS) {
      scrollToBlock(FttbBlocks.TARIFFS, {
        behavior: 'smooth',
        block: 'start'
      });
    }
    sendAnalyticsOnHeadingBannerClick({
      bannerTitle: title,
      pageType: pageType,
      url: button.link
    });
  }, [button.link]);
  return (
    /*#__PURE__*/
    // @ts-expect-error won't fix
    React.createElement(TeaserBanner, _extends({}, props, {
      button: _objectSpread(_objectSpread({}, button), {}, {
        onClick: onClick
      }),
      title: title,
      "data-t-id": "HeadingBlock-components"
    }))
  );
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    analyticBlockTitle: getHeadingTitle(state),
    backgroundColor: getHeadingBackgroundColor(state),
    button: {
      link: getHeadingBannerButtonLink(state),
      text: getHeadingBannerButtonText(state),
      variant: getVariant(state)
    },
    img: {
      src: getTitleImgUrl(state)
    },
    pageType: getAnalyticEventType(state),
    text: getHeadingBannerText(state),
    textColor: getTextColor(state),
    title: getHeadingTitle(state),
    titleColor: getTitleColor(state),
    withDivider: getIsDivider(state)
  };
};
var connector = connect(mapStateToProps);
var _HeadingBannerHOC = withAnalyticsOnBlockView(_HeadingBanner);
export var HeadingBanner = connector(_HeadingBannerHOC);